import { apiService } from "@/_services";

/**
 * Retrieves correlation data for relative values
 * @param {object} ctx: context variables
 * @param {object} params: query parameters
 */
export function processCorrelations(ctx, params) {
  return apiService
    .getAll(params)
    .then(data => {
      data = JSON.parse(JSON.stringify(data));
      ctx.correlColumns = data.map(d =>
        d.row === "close" ? ctx.currencyString.currency_name : d.row
      );
      ctx.correlation = [];
      let i, j, idx, idx2;
      for (i = 0; i < data.length; i++) {
        idx =
          data[i].row === "close"
            ? ctx.currencyString.currency_name
            : data[i].row;
        for (j = 0; j < ctx.correlColumns.length; j++) {
          idx2 =
            ctx.correlColumns[j] === ctx.currencyString.currency_name
              ? "close"
              : ctx.correlColumns[j];
          ctx.correlation.push({
            x: idx,
            y: ctx.correlColumns[j],
            correl: +data[i][idx2]
          });
        }
      }
      ctx.showLoadingCorrel = false;
    })
    .catch(function(error) {
      ctx.showLoadingCorrel = false;
      console.log(error);
    });
}
